module.exports = __webpack_public_path__ + "media/images/features/7/plan-konintodoke1-559813c60169e14f3f7f9ffec843dad6.png";